export const SortOptions = {
    NAME: 'name',
    DATE: 'created_at',
    ID_COUNT: 'id_count',
    UPDATED_AT: 'updated_at',
    URL_COUNT: 'url_count',
};
